import * as React from 'react';

import './Header.css';

interface IHeaderProps {
    header: string;
    subHeader?: string;
    additionalNotes?: string;
}

interface IHeaderState {
    
}

class Header extends React.Component<IHeaderProps, IHeaderState> {

    constructor(props: IHeaderProps) {
        super(props);

        this.state = {
            
        };
    }

    render() {
        return (
            <div className={'Header'}>
                <div className={'Header-header'}>
                    {this.props.header}
                </div>
                <div className={'Header-subHeader'}>
                    {this.props.subHeader}
                </div>
                {
                    this.props.additionalNotes && 
                    <div className={'Header-additionalNotes'}>
                        {this.props.additionalNotes}
                    </div>
                }
            </div>
        );
    }
}

export default Header;
